<template>
  <b-modal
    id="modal-details-product"
    size="lg"
    hide-footer
    hide-header
    centered
    title="Emitir"
  >
    <div>
      <div class="headerModal">
        <div
          style="
            display: flex;
            align-items: center;
            gap: 1rem;
            position: relative;
          "
        >
          <div class="contentIconHeader" style="width: 40px; height: 40px">
            <b-icon-file-earmark-text
              style="width: 20px; height: 20px; color: white"
            />
          </div>

          <h6 class="titleModal">Detalhes Técnicos do Produto</h6>

          <div
            class="contentCloseIcon"
            @click="$bvModal.hide('modal-details-product')"
          >
            <b-icon-x-lg style="width: 12px; height: 12px; color: white" />
          </div>
        </div>

        <p
          style="
            margin: 0 0 0 3.5rem;
            color: #ffffffde;
            font-size: 0.8rem;
            font-weight: 500;
          "
        >
          Informações completas sobre o produto {{ getProduct?.nome }}
        </p>
      </div>

      <div style="padding: 1rem 1rem 0 1rem">
        <p
          style="
            margin: 0;
            color: oklch(54.6% 0.245 262.881);
            font-size: 1.2rem;
            font-weight: 600;
            border-bottom: solid 1px #8080804d;
          "
        >
          {{ getProduct?.nome }}
        </p>
      </div>

      <div class="cardOverflow">
        <div class="btnModal">
          <div class="btnActionModal">
            <div
              style="
                display: flex;
                align-items: center;
                gap: 1rem;
                padding: 1rem 1.2rem;
              "
            >
              <div
                class="contentIconHeader"
                style="background-color: oklch(93.2% 0.032 255.585)"
              >
                <b-icon-droplet-fill
                  style="
                    width: 16px;
                    height: 16px;
                    color: oklch(0.51 0.3 262.26);
                  "
                />
              </div>

              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                "
              >
                <p style="margin: 0; font-size: 1rem; color: black">
                  Dados produto, cultura e diagnóstico
                </p>
              </div>
            </div>

            <div class="containerColItem">
              <div class="contentColItem">
                <p>Cultura</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{ getProduct?.infortecnicaReceita?.nomeCultura || "--" }}
                </p>
              </div>

              <div class="contentColItem">
                <p>Diagnóstico/Alvo</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{ getProduct?.infortecnicaReceita?.nomeProblema || "--" }}
                </p>
              </div>

              <div class="contentColItem">
                <p>Dose Utilizada</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{ getProduct?.infortecnicaReceita?.doseUtilizada || "--" }}
                </p>
              </div>

              <div class="contentColItem">
                <p>Volume Calda Utilizado</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{
                    getProduct?.infortecnicaReceita?.volumeCaldaUtilizado ||
                    "--"
                  }}
                </p>
              </div>

              <div class="contentColItem">
                <p>Intervalo de Aplicação</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{ getProduct?.infortecnicaReceita?.intervaloAplicacao || 0 }}
                </p>
              </div>

              <div class="contentColItem">
                <p>Intervalo de Segurança</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{ getProduct?.infortecnicaReceita?.intervaloSeguranca || 0 }}
                </p>
              </div>

              <div class="contentColItem">
                <p>Nº de Aplicações</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{ getProduct?.infortecnicaReceita?.numAplicacoes || 0 }}
                </p>
              </div>

              <div class="contentColItem">
                <p>Forma de Aplicação</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{ getProduct?.infortecnicaReceita?.formaAplicacao || "--" }}
                </p>
              </div>
            </div>

            <div class="containerColItem" style="grid-template-columns: 1fr">
              <div class="contentColItem">
                <p>Época de Aplicação</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{ getProduct?.infortecnicaReceita?.epocaAplicacao || "--" }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="btnModal">
          <div class="btnActionModal">
            <div
              style="
                display: flex;
                align-items: center;
                gap: 1rem;
                padding: 1rem 1.2rem;
              "
            >
              <div
                class="contentIconHeader"
                style="background-color: oklch(93.2% 0.032 255.585)"
              >
                <b-icon-info-circle
                  style="
                    width: 16px;
                    height: 16px;
                    color: oklch(0.51 0.3 262.26);
                  "
                />
              </div>

              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                "
              >
                <p style="margin: 0; font-size: 1rem; color: black">
                  Dados Técnicos
                </p>
              </div>
            </div>

            <div class="containerColItem">
              <div class="contentColItem">
                <p>Área a Tratar</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{ getProduct?.infortecnicaReceita?.areatratar || "--" }}

                  <span style="margin-left: 0.3rem; text-transform: capitalize">
                    {{ getProduct?.infortecnicaReceita?.medida }}
                  </span>
                </p>
              </div>

              <div class="contentColItem">
                <p>Qt. Embalagem</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{ getProduct?.quantidade || "--" }}
                </p>
              </div>

              <div class="contentColItem" style="grid-column: 1 / 4">
                <p>Embalagem</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{ getProduct?.infortecnicaReceita?.embalagem || "--" }}
                </p>
              </div>

              <div class="contentColItem" style="grid-column: 1 / 3">
                <p>Modalidade de Aplicação</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{
                    getProduct?.infortecnicaReceita?.nomeTipoAplicacao || "--"
                  }}
                </p>
              </div>

              <div class="contentColItem">
                <p>Lote</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{ getProduct?.infortecnicaReceita?.lote || "--" }}
                </p>
              </div>

              <div
                class="contentColItem"
                style="
                  grid-column: 1 / 4;
                  border-top: solid 1px oklch(0.922 0 0);
                  padding-top: 0.5rem;
                "
              >
                <p>Modo de Aplicação</p>

                <p style="margin: 0; font-size: 0.7rem">
                  {{ getProduct?.infortecnicaReceita?.modoaplicacao || "--" }}
                </p>
              </div>
            </div>

            <!-- <div class="containerColItem" style="grid-template-columns: 1fr">
              <div class="contentColItem">
                <p>Época de Aplicação</p>

                <p style="margin: 0; font-size: 0.775rem">
                  {{ getProduct?.infortecnicaReceita?.epocaAplicacao || "--" }}
                </p>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    product: {
      typeof: Object,
    },
  },
  data() {
    return {
      isOtherPrints: false,
      typeIntegration: "stone",
      machineTypes: [
        { text: "Stone", value: "stone" },
        { text: "Vero", value: "vero" },
      ],
    };
  },
  methods: {},
  computed: {
    getProduct() {
      return this.product;
    },
  },
};
</script>

<style scoped>
.titleModal {
  font-size: 1.2rem;
  color: white;
  font-weight: 500;
  margin: 0;
}

.containerColItem {
  padding: 0 1.2rem 1rem 1.2rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem 2rem;
}

.contentColItem {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.contentColItem p:first-child {
  margin: 0;
  font-size: 0.65rem;
  color: oklch(0.556 0 0);
  text-transform: uppercase;
}

.cardOverflow {
  overflow: auto;
  max-height: 60vh;
  padding: 1rem 1.2rem 1rem 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

*::-webkit-scrollbar {
  width: 5px;
  height: 8px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: oklch(54.6% 0.245 262.881);
}

/* MODAL STYLE */

::v-deep(.modal-body) {
  padding: 0;
}

::v-deep(.modal-content) {
  border-radius: 0.625rem;
}

.headerModal {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 1rem 1.2rem;
  background-color: oklch(54.6% 0.245 262.881);
  border-radius: 0.5rem 0.5rem 0 0;
}

.contentCloseIcon {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255 255 255 / 17%);
  border-radius: 50%;
  position: absolute;
  right: -10px;
  top: -10px;
  cursor: pointer;
  transition: ease-in all 0.1s;
}

.contentCloseIcon:hover {
  background-color: rgba(255, 255, 255, 0.376);
  transition: ease-in all 0.1s;
}

.btnModal {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  justify-content: space-around;
}

.btnActionModal {
  width: 100%;
  outline: none;
  border: none;
  border-radius: 5px;
  box-shadow: 0 0 2px 1px rgba(128, 128, 128, 0.248);
  background-color: transparent;
  transition: ease-in all 0.1s;
}

.btnActionModal:hover {
  transition: ease-in all 0.1s;
  box-shadow: 0 1px 5px 1px rgba(0, 0, 0, 0.149);
}

.contentIconHeader {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255 255 255 / 17%);
  border-radius: 8px;
}
</style>